<template>
  <div class="stock-match-row" :class="{ 'stock-match-row--missing': matches === false }">
    <span
      v-if="mark"
      class="stock-match-row__mark"
      :class="`stock-match-row__mark--${mark.modifier}`"
    >
      <icon :icon="mark.icon" :width="mark.size" :height="mark.size" :title="mark.title" />
    </span>
    <span class="stock-match-row__code">{{ code }}</span>
    <span class="stock-match-row__name" :title="name">{{ name }}</span>
  </div>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: { Icon },
  props: {
    code: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    // true or false marks the row as present or missing; leave it out for no mark.
    matches: {
      type: Boolean,
      default: null,
    },
    extra: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    mark() {
      if (this.extra) return { modifier: 'extra', icon: 'plus', size: 10 }
      if (this.matches === true)
        return {
          modifier: 'ok',
          icon: 'check',
          size: 10,
          title: this.i18n.t('/stockmatch/present'),
        }
      if (this.matches === false)
        return {
          modifier: 'missing',
          icon: 'cross',
          size: 8,
          title: this.i18n.t('/stockmatch/missing'),
        }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.stock-match-row {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: 0;
}

.stock-match-row__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: var(--ds-color-surface);

  &--ok {
    background: var(--ds-color-success);
  }

  &--missing {
    background: var(--ds-color-danger-text);
  }

  &--extra {
    border: 1.5px solid var(--ds-color-text);
    color: var(--ds-color-text);
  }
}

.stock-match-row__code {
  flex-shrink: 0;
  min-width: 2.75rem;
  font-family: $font-family-mono;
  font-size: var(--ds-font-size-sm);
  color: var(--ds-color-text-muted);
}

.stock-match-row__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  .stock-match-row--missing & {
    color: var(--ds-color-text-subtle);
  }
}
</style>
